export const mockArticles = [
  {
    id: '1',
    title: 'Prefeitura anuncia novo plano de mobilidade urbana para 2026',
    author: 'Carlos Mendes',
    excerpt: 'A administração municipal apresentou um ambicioso projeto de reestruturação do transporte público, com investimentos de R$ 2,4 bilhões previstos para os próximos três anos.',
    content: 'A administração municipal apresentou ontem um ambicioso projeto de reestruturação do transporte público da cidade, com investimentos de R$ 2,4 bilhões previstos para os próximos três anos. O plano inclui a criação de 15 novos corredores de ônibus, expansão do metrô e implantação de ciclovias integradas.',
    section: 'Política',
    priority: 'alta',
    tags: ['mobilidade', 'prefeitura', 'transporte'],
    status: 'aprovado',
    wordCount: 842,
    createdAt: '2026-04-06T09:30:00Z',
    updatedAt: '2026-04-06T14:20:00Z',
    image: 'https://public.readdy.ai/ai/img_res/7a07ecb445fb3c89a80d4aed63ef697e.jpg',
  },
  {
    id: '2',
    title: 'Seleção brasileira convoca 26 jogadores para amistosos de junho',
    author: 'Fernanda Lima',
    excerpt: 'O técnico nacional divulgou a lista de convocados para os dois amistosos preparatórios, com surpresas na defesa e retorno de veteranos ao grupo.',
    content: 'O técnico da seleção brasileira divulgou nesta manhã a lista de 26 jogadores convocados para os amistosos de junho. A lista traz surpresas na defesa com a convocação de dois jovens talentos e o retorno de veteranos importantes ao grupo.',
    section: 'Esportes',
    priority: 'alta',
    tags: ['futebol', 'seleção', 'convocação'],
    status: 'revisão',
    wordCount: 620,
    createdAt: '2026-04-06T11:00:00Z',
    updatedAt: '2026-04-06T11:45:00Z',
    image: 'https://readdy.ai/api/search-image?query=brazilian%20football%20team%20training%20field%20green%20grass%20stadium%20crowd%20cheering&width=800&height=450&seq=art2&orientation=landscape',
  },
  {
    id: '3',
    title: 'Festival de Cinema de Jardel City bate recorde de público',
    author: 'Ana Paula Rocha',
    excerpt: 'A 12ª edição do festival recebeu mais de 80 mil visitantes em cinco dias, consolidando o evento como o maior da região sul do país.',
    content: 'A 12ª edição do Festival de Cinema de Jardel City encerrou suas atividades com recorde histórico de público. Mais de 80 mil visitantes passaram pelos cinemas e espaços culturais da cidade durante os cinco dias do evento.',
    section: 'Cultura',
    priority: 'média',
    tags: ['cinema', 'festival', 'cultura'],
    status: 'publicado',
    wordCount: 510,
    createdAt: '2026-04-05T16:00:00Z',
    updatedAt: '2026-04-05T18:30:00Z',
    image: 'https://readdy.ai/api/search-image?query=film%20festival%20cinema%20red%20carpet%20crowd%20lights%20celebration%20cultural%20event&width=800&height=450&seq=art3&orientation=landscape',
  },
  {
    id: '4',
    title: 'Startup local levanta R$ 15 milhões em rodada série A',
    author: 'Roberto Alves',
    excerpt: 'A fintech jardel-cityense Credix fechou rodada de investimento com fundo americano, planejando expansão para cinco novos estados.',
    content: 'A startup de tecnologia financeira Credix, fundada em Jardel City, anunciou o fechamento de uma rodada série A de R$ 15 milhões liderada pelo fundo americano TechVentures. Os recursos serão utilizados para expansão das operações para cinco novos estados brasileiros.',
    section: 'Economia',
    priority: 'média',
    tags: ['startup', 'fintech', 'investimento'],
    status: 'rascunho',
    wordCount: 380,
    createdAt: '2026-04-07T08:00:00Z',
    updatedAt: '2026-04-07T08:00:00Z',
    image: 'https://readdy.ai/api/search-image?query=startup%20office%20modern%20technology%20team%20working%20computers%20investment%20growth%20chart&width=800&height=450&seq=art4&orientation=landscape',
  },
  {
    id: '5',
    title: 'Pesquisadores descobrem nova espécie de orquídea na Mata Atlântica',
    author: 'Juliana Costa',
    excerpt: 'Equipe da Universidade Federal identificou planta nunca catalogada durante expedição científica na Serra do Mar, região de Jardel City.',
    content: 'Pesquisadores da Universidade Federal de Jardel City anunciaram a descoberta de uma nova espécie de orquídea durante expedição científica realizada na Serra do Mar. A planta, batizada de Cattleya jardelensis, apresenta características únicas de coloração e adaptação ao clima local.',
    section: 'Ciência',
    priority: 'baixa',
    tags: ['ciência', 'natureza', 'descoberta'],
    status: 'revisão',
    wordCount: 445,
    createdAt: '2026-04-06T14:00:00Z',
    updatedAt: '2026-04-06T15:10:00Z',
    image: 'https://readdy.ai/api/search-image?query=rare%20orchid%20flower%20discovery%20tropical%20rainforest%20botanical%20research%20scientist%20nature&width=800&height=450&seq=art5&orientation=landscape',
  },
  {
    id: '6',
    title: 'Governo estadual lança programa de habitação para 50 mil famílias',
    author: 'Marcos Vieira',
    excerpt: 'Iniciativa prevê construção de 12 mil unidades habitacionais em parceria com municípios da região metropolitana até 2028.',
    content: 'O governo estadual lançou ontem o programa Morar Bem, que prevê a construção de 12 mil unidades habitacionais para atender 50 mil famílias de baixa renda na região metropolitana. O investimento total é de R$ 3,8 bilhões, com recursos federais e estaduais.',
    section: 'Política',
    priority: 'alta',
    tags: ['habitação', 'governo', 'social'],
    status: 'aprovado',
    wordCount: 720,
    createdAt: '2026-04-07T07:30:00Z',
    updatedAt: '2026-04-07T09:00:00Z',
    image: 'https://readdy.ai/api/search-image?query=housing%20construction%20residential%20buildings%20urban%20development%20government%20program%20families&width=800&height=450&seq=art6&orientation=landscape',
  },
];

export const mockSections = ['Política', 'Esportes', 'Cultura', 'Economia', 'Ciência', 'Internacional', 'Saúde', 'Tecnologia', 'Opinião'];

export const mockAuthors = ['Carlos Mendes', 'Fernanda Lima', 'Ana Paula Rocha', 'Roberto Alves', 'Juliana Costa', 'Marcos Vieira', 'Patricia Santos', 'Diego Ferreira'];

export const mockStatuses = ['rascunho', 'revisão', 'aprovado', 'publicado'];
